import {useCallback} from 'react';
import {useBeforeunload} from 'react-beforeunload';

export function usePreventWindowUnload(shouldConfirm) {
    const handler = useCallback((event: Event) => {
        event.preventDefault();
        event.returnValue = false;
        return '';
    }, []);

    useBeforeunload((event: Event) => {
        if (shouldConfirm) {
            handler(event);
        }
    });
}
